var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66699 8.34153L7.22779 9.90066C7.97847 8.58802 9.01736 7.46292 10.2661 6.6102L10.3337 6.56409M14.1004 8.00002C14.1004 11.369 11.3693 14.1 8.00039 14.1C4.63145 14.1 1.90039 11.369 1.90039 8.00002C1.90039 4.63109 4.63145 1.90002 8.00039 1.90002C11.3693 1.90002 14.1004 4.63109 14.1004 8.00002Z",
    stroke: "#17B26A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.c9b79084f2ba1b4fd677998fade7f483.svg";
export { ForwardRef as ReactComponent };